/* eslint-disable max-len */
const PawGraphic = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8843 22.4C22.1243 19.2064 21.5787 18.4 19.5643 18.4C17.5499 18.4 16.7867 19.608 15.0267 22.7952C13.5195 25.52 10.4731 25.7472 9.71312 28.0608C9.55792 28.4848 9.48112 29.144 9.48432 29.6C9.48432 31.4816 10.7435 32.8 12.3643 32.8C14.3787 32.8 17.1707 31.2 19.5643 31.2C21.9579 31.2 24.7499 32.8 26.7643 32.8C28.3851 32.8 29.6443 31.4832 29.6443 29.6C29.6443 29.144 29.5659 28.4848 29.4107 28.0608C28.6507 25.7392 25.3915 25.1248 23.8843 22.4Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.6651 13.7313C32.4596 13.6444 32.2387 13.5998 32.0155 13.6001H31.9915C30.8155 13.6193 29.4955 14.8001 28.8027 16.5857C27.9723 18.7217 28.3547 20.9057 29.6635 21.4689C29.8699 21.5569 30.0907 21.6001 30.3131 21.6001C31.4955 21.6001 32.8331 20.4129 33.5307 18.6145C34.3563 16.4785 33.9675 14.2945 32.6667 13.7313H32.6651Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5227 15.2001C15.6107 15.2001 15.6971 15.1937 15.7835 15.1825C17.2939 14.9777 18.2363 13.0289 17.8955 10.8273C17.5707 8.75207 16.2203 7.20007 14.8043 7.20007C14.7163 7.20007 14.6299 7.20647 14.5435 7.21767C13.0331 7.42247 12.0907 9.37127 12.4315 11.5729C12.7579 13.6417 14.1083 15.2001 15.5243 15.2001H15.5227Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6939 11.5729C27.0363 9.37128 26.0939 7.42248 24.5819 7.21768C24.496 7.20578 24.4094 7.1999 24.3227 7.20008C22.9067 7.20008 21.5579 8.75208 21.2347 10.8273C20.8923 13.0289 21.8347 14.9777 23.3467 15.1825C23.4331 15.1937 23.5195 15.2001 23.6059 15.2001C25.0219 15.2001 26.3739 13.6417 26.6939 11.5729V11.5729Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.46833 21.4689C10.7739 20.9057 11.1547 18.7185 10.3259 16.5857C9.62833 14.7873 8.29233 13.6001 7.11153 13.6001C6.88753 13.6001 6.66833 13.6433 6.46033 13.7313C5.15473 14.2945 4.77393 16.4817 5.60273 18.6145C6.30033 20.4129 7.63633 21.6001 8.81713 21.6001C9.04113 21.6001 9.26033 21.5569 9.46833 21.4689Z"
        />
      </g>
    </svg>
  );
};

export default PawGraphic;
